import React from "react";
import { Flex } from "grid-styled";
import { graphql } from "react-apollo";
import { Redirect } from "react-router-dom";
import { gql } from "apollo-boost";
import PulseLoader from "./PulseLoader";
import NotFound from "./NotFound";
import { P } from "./Text";
import Button, { LinkButton } from "./Button";
import { IntercomAPI } from "react-intercom";

const openIntercom = () => IntercomAPI("showNewMessage");

const Index = ({ loading, currentUser }) => {
  if (loading)
    return (
      <Flex
        style={{ height: "100vh", width: "100vw" }}
        justify="center"
        align="center"
      >
        <PulseLoader size={14} />
      </Flex>
    );

  if (currentUser) {
    if (currentUser.role.match(/admin|manager|draftsman/)) {
      return <Redirect to="/admin" />;
    }

    const { franchiseMemberships } = currentUser;

    if (!franchiseMemberships.length) {
      return (
        <Flex
          style={{ height: "100vh", width: "100vw" }}
          justify="center"
          align="center"
        >
          <NotFound>
            <P>It looks like your user does not belong to any franchises.</P>
            <LinkButton variant="primary" to="/login">
              Change accounts
            </LinkButton>{" "}
            <Button onClick={openIntercom}>Contact support</Button>
          </NotFound>
        </Flex>
      );
    }

    const franchise = currentUser.franchiseMemberships[0].franchise;
    return <Redirect to={`/${franchise.slug}`} />;
  }

  return <Redirect to="/login" />;
};

const currentUserPermissionsQuery = gql`
  query CurrentUserPermissionsQuery {
    currentUser {
      id
      role
      franchiseMemberships {
        franchise {
          id
          name
          slug
        }
      }
    }
  }
`;

export default graphql(currentUserPermissionsQuery, {
  props: ({ data: { loading, currentUser } }) => ({
    loading,
    currentUser
  })
})(Index);



// WEBPACK FOOTER //
// ./src/components/Index.js